import React, { useContext, useEffect, } from 'react';
// import { FaArrowRightLong } from "react-icons/fa6";
import { FormContext } from '../Provider';
// import { useNavigate } from 'react-router-dom';
// import { useParams } from 'react-router-dom';

export default function EditPersonal({ step, setStep, id }) {
    // const navigate = useNavigate();
    const { editPersonal, setEditPersonal, imagePreview, setImagePreview, imageProfilePreview, setImageProfilePreview } = useContext(FormContext);
    const api = process.env.REACT_APP_URL;

    // Debug logs
    console.log("API URL:", api);
    console.log("Student ID from props:", id);

    // useEffect(() => {
    //     console.log("🔥 useEffect triggered with id:", id, "and api:", api);
    //     // rest of code
    // }, []);


    // Debug line

    useEffect(() => {
        // Only proceed if both api and id are available
        if (!api || !id) {
            console.log("Missing required values:", { api, id });
            return;
        }

        console.log("Fetching data for student ID:", id);
        fetch(`${api}/studentData/${id}`, {
            method: "GET",
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                console.log("Fetched personal data:", data);
                if (data.success && data.studentData) {
                    setEditPersonal(prev => {
                        const existingFile = prev?.personalData?.proofImage;
                        const isNewFile = existingFile instanceof File;

                        const existingProfileFile = prev?.personalData?.profilePic
                        const isNewProfileFile = existingProfileFile instanceof File

                        return {
                            ...data.studentData,
                            personalData: {
                                ...data.studentData.personalData,
                                proofImage: isNewFile ? existingFile : data.studentData.personalData.proofImage,
                                profilePic: isNewProfileFile ? existingProfileFile : data.studentData.personalData.profilePic

                            }
                        };
                    });

                } else {
                    throw new Error(data.message || 'Failed to fetch student data');
                }
            })
            .catch(err => {
                console.error("Error fetching personal data:", err.message);
            });
    }, [api, id, setEditPersonal]) // Added setEditPersonal to dependency array


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Clean up previous preview if exists
            if (imagePreview) {
                URL.revokeObjectURL(imagePreview);
            }

            // Create new preview
            const preview = URL.createObjectURL(file);

            setEditPersonal(prev => ({
                ...prev,
                personalData: {
                    ...prev.personalData,
                    proofImage: file
                }
            }));




            // Set new preview
            setImagePreview(preview);
        }
    };

    // Profile Pic:
    const handleProfileFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Clean up previous preview if exists
            if (imageProfilePreview) {
                URL.revokeObjectURL(imageProfilePreview);
            }

            // Create new preview
            const preview = URL.createObjectURL(file);

            setEditPersonal(prev => ({
                ...prev,
                personalData: {
                    ...prev.personalData,
                    profilePic: file
                }
            }));




            // Set new preview
            setImageProfilePreview(preview);
        }
    };


    // Revoke object URL on cleanup
    // Cleanup function for image preview
    // useEffect(() => {
    //     return () => {
    //         if (imagePreview) {
    //             URL.revokeObjectURL(imagePreview);
    //             setImagePreview(null);
    //         }
    //     };
    // }, [imagePreview, setImagePreview]);

    // Cleanup when component unmounts
    // useEffect(() => {
    //     return () => {
    //         setImagePreview(null);
    //     };
    // }, [setImagePreview]);

    console.log(`${api}/upload/${editPersonal?.personalData?.proofImage?.filename}`);
    console.log(`${api}/upload/${editPersonal?.personalData?.profilePic?.filename}`);


    const handleSubmit = (e) => {
        e.preventDefault();
        // if (imagePreview) {
        //     URL.revokeObjectURL(imagePreview);
        //     setImagePreview(null);
        // }
        setStep(step + 1);
        // navigate(`/admin-forms/${id}`);
    };

    return (
        <section>

            <div className="w-full pt-2">
                <section className="bg-white rounded-lg shadow-md p-4 sm:p-6">
                    <div className="bg-gray-100 px-2 sm:px-4 py-4 w-full">
                        <div className="flex justify-center items-center w-full">
                            <div className="w-full max-w-lg md:max-w-4xl mx-auto px-0 sm:px-2">
                                <div className="card shadow-lg  rounded-xl">
                                    <div className="card-body p-3 sm:p-5">
                                        <h3 className="font-bold text-lg text-primary-800">
                                            Personal Details
                                        </h3>

                                        <form >
                                            {/* Full Name Field */}
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mt-8">
                                                {/* Full Name Field */}
                                                <div className="mb-4 w-full">
                                                    <div className="relative">
                                                        <input
                                                            type="text"
                                                            id="fullname"
                                                            value={editPersonal.personalData.name || ''}
                                                            onChange={(e) => setEditPersonal({ ...editPersonal, personalData: { ...editPersonal.personalData, name: e.target.value } })}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" "
                                                            required
                                                        />
                                                        <label
                                                            htmlFor="fullname"
                                                            className="absolute text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[3] bg-white dark:bg-gray-900 px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 start-1 font-medium text-base"
                                                        >
                                                            Full Name
                                                        </label>
                                                    </div>

                                                </div>

                                                {/* Date of Birth Field */}
                                                <div className="mb-4 w-full">
                                                    <div className="relative">
                                                        <input
                                                            type="date"
                                                            id="dob"
                                                            value={editPersonal.personalData.dob ? editPersonal.personalData.dob.split('T')[0] : ''}
                                                            onChange={(e) => setEditPersonal({ ...editPersonal, personalData: { ...editPersonal.personalData, dob: e.target.value } })}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" "
                                                            required
                                                        />
                                                        <label
                                                            htmlFor="dob"
                                                            className="absolute text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[3] bg-white px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1 font-medium"
                                                        >
                                                            Date of Birth
                                                        </label>
                                                    </div>

                                                </div>
                                            </div>


                                            {/* Parent  and Gender */}
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <input
                                                            type="text"
                                                            id="parentName"
                                                            value={editPersonal.personalData.guardianName}
                                                            onChange={(e) => setEditPersonal({ ...editPersonal, personalData: { ...editPersonal.personalData, guardianName: e.target.value } })}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" "
                                                        />
                                                        <label htmlFor="parentName" className="absolute  text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[3] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 
                                                        peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1  text-base font-medium"> Parent's / Guardian Name
                                                        </label>
                                                    </div>

                                                </div>

                                                <div className="mb-4 w-full">
                                                    <h6 className="mb-2 pb-1 font-medium">Gender:</h6>

                                                    <div className="flex flex-col sm:flex-row sm:items-center sm:gap-6 gap-3">
                                                        {/* Male */}
                                                        <div className="flex items-center">
                                                            <input
                                                                id="male"
                                                                type="radio"
                                                                name="gender"
                                                                value="male"
                                                                onChange={(e) => setEditPersonal({ ...editPersonal, personalData: { ...editPersonal.personalData, gender: e.target.value } })}
                                                                checked={editPersonal.personalData.gender === 'male'}
                                                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  dark:bg-gray-700 dark:border-gray-600"
                                                                required
                                                            />
                                                            <label htmlFor="male" className="ms-2 text-sm font-medium text-gray-900 ">
                                                                Male
                                                            </label>
                                                        </div>

                                                        {/* Female */}
                                                        <div className="flex items-center">
                                                            <input
                                                                id="female"
                                                                type="radio"
                                                                name="gender"
                                                                value="female"
                                                                onChange={(e) => setEditPersonal({ ...editPersonal, personalData: { ...editPersonal.personalData, gender: e.target.value } })}
                                                                checked={editPersonal.personalData.gender === 'female'}
                                                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  dark:bg-gray-700 dark:border-gray-600"
                                                            />
                                                            <label htmlFor="female" className="ms-2 text-sm font-medium text-gray-900 ">
                                                                Female
                                                            </label>
                                                        </div>

                                                        {/* Other */}
                                                        <div className="flex items-center">
                                                            <input
                                                                id="other"
                                                                type="radio"
                                                                name="gender"
                                                                value="other"
                                                                checked={editPersonal.personalData.gender === 'other'}
                                                                onChange={(e) => setEditPersonal({ ...editPersonal, personalData: { ...editPersonal.personalData, gender: e.target.value } })}
                                                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  dark:bg-gray-700 dark:border-gray-600"
                                                            />
                                                            <label htmlFor="other" className="ms-2 text-sm font-medium text-gray-900 ">
                                                                Other
                                                            </label>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                            {/* Address and Pincode */}
                                            <div className="grid grid-cols">
                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <textarea
                                                            type="text"
                                                            id="address"
                                                            value={editPersonal.personalData.address}
                                                            onChange={(e) => setEditPersonal({ ...editPersonal, personalData: { ...editPersonal.personalData, address: e.target.value } })}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" " required
                                                        />
                                                        <label htmlFor="address" className="absolute  text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[3] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 
                                                        peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 font-medium text-base">Address</label>
                                                    </div>

                                                </div>


                                            </div>

                                            {/* Contact and Alternative Number */}
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <input
                                                            type="number"
                                                            id="contactNumber"
                                                            value={editPersonal.personalData.contact}
                                                            onChange={(e) => setEditPersonal({ ...editPersonal, personalData: { ...editPersonal.personalData, contact: e.target.value } })}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" " required
                                                        />
                                                        <label htmlFor="contactNumber" className="absolute  text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600
                                                     peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 font-medium text-base">Contact Number</label>
                                                    </div>

                                                </div>

                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <input
                                                            type="number"
                                                            id="alternateNumber"
                                                            value={editPersonal.personalData.alternateNumber}
                                                            onChange={(e) => setEditPersonal({ ...editPersonal, personalData: { ...editPersonal.personalData, alternateNumber: e.target.value } })}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" "
                                                        />
                                                        <label htmlFor="alternateNumber" className="absolute  text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 
                                                    peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 font-medium text-base"> Alternative Contact Number
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                {/* Email Field */}
                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <input
                                                            type="email"
                                                            id="emailAddress"
                                                            value={editPersonal.personalData.email}
                                                            onChange={(e) => setEditPersonal({ ...editPersonal, personalData: { ...editPersonal.personalData, email: e.target.value } })}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" " required
                                                        />
                                                        <label htmlFor="emailAddress" className="absolute  text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[3] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 
                                                        peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 font-medium text-base"> Email
                                                        </label>
                                                    </div>

                                                </div>

                                                {/* Pincode Field */}
                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <input
                                                            type="number"
                                                            id="pincode"
                                                            value={editPersonal.personalData.pincode}
                                                            onChange={(e) => setEditPersonal({
                                                                ...editPersonal, personalData: {
                                                                    ...editPersonal.personalData, pincode: e.target.value
                                                                }
                                                            })}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" " required
                                                        />
                                                        <label htmlFor="pincode" className="absolute  text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[3] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 
                                                        peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 font-medium text-base"> Pincode
                                                        </label>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                {/* Emergency Contact Field */}
                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <input
                                                            type="number"
                                                            id="emergency"
                                                            value={editPersonal.personalData.emergencyContact}
                                                            onChange={(e) => setEditPersonal({ ...editPersonal, personalData: { ...editPersonal.personalData, emergencyContact: e.target.value } })}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" " required
                                                        />
                                                        <label htmlFor="emergency" className="absolute  text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[3] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                                                         peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 font-medium text-base"> Emergency Contact Number
                                                        </label>
                                                    </div>

                                                </div>

                                                {/* Proof of Identity Selection */}
                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <select
                                                            id="proofOfIdentity"
                                                            value={editPersonal.personalData.proof}
                                                            onChange={(e) => setEditPersonal({ ...editPersonal, personalData: { ...editPersonal.personalData, proof: e.target.value } })}

                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" required
                                                        >
                                                            <option value="" disabled>
                                                                Select Proof of Identity
                                                            </option>
                                                            <option> ID card</option>
                                                            <option value="aadhaar">Aadhaar</option>
                                                            <option value="passport">Passport</option>
                                                            <option value="voterId">Voter ID</option>
                                                            <option value="drivingLicense">Driving License</option>
                                                        </select>
                                                        {/* Dropdown arrow icon */}
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            className="w-4 h-4 text-gray-500 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M5.23 7.79a1 1 0 011.41 0L10 11.12l3.36-3.33a1 1 0 111.42 1.41l-4 4a1 1 0 01-1.42 0l-4-4a1 1 0 010-1.41z"
                                                                clipRule="evenodd"
                                                            />
                                                        </svg>
                                                        <label
                                                            htmlFor="proofOfIdentity"
                                                            className="absolute  text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[3] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:scale-75 peer-focus:-translate-y-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 font-medium text-base"
                                                        >
                                                            Proof of Identity
                                                        </label>
                                                    </div>

                                                </div>

                                            </div>

                                            {/* editPersonal.personalData.proofImage && editPersonal.personalData.proofImage.filename ? (
                                            ) : (
                                            <p className="text-sm text-gray-500">No proof image available</p>
                                            ) */}

                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" >
                                                <div>
                                                    <label className='font-medium mb-3'>Proof File:</label>
                                                    <div className="flex items-center justify-center w-full">
                                                        <label
                                                            htmlFor="dropzone-fileee"
                                                            className={`flex flex-col items-center justify-center w-full h-44 cursor-pointer  `}
                                                        >
                                                            {/* 👇 Conditional Preview or Default SVG Instructions */}

                                                            <div className="flex items-center justify-start w-full h-full">
                                                                {
                                                                    imagePreview ? (
                                                                        <img
                                                                            src={imagePreview}
                                                                            alt="Preview"
                                                                            className="h-full object-contain border-2 border-gray-300 border-dashed rounded-lg"
                                                                        />
                                                                    ) :

                                                                        (editPersonal?.personalData?.proofImage?.filename ? (
                                                                            <img
                                                                                src={`${api}/upload/${editPersonal.personalData.proofImage.filename}`}
                                                                                alt={editPersonal.personalData.proofImage.filename}
                                                                                className="h-full object-contain border-2 border-gray-300 border-dashed rounded-lg"
                                                                            />


                                                                        ) : (
                                                                            <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                                                                <svg className="w-8 h-8 mb-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                                                                </svg>
                                                                                <p className="mb-2 text-sm text-gray-500"><span className="font-semibold">Click to upload</span> or drag and drop</p>
                                                                                <p className="text-xs text-gray-500">SVG, PNG, JPG or GIF (MAX. 800x400px)</p>
                                                                            </div>
                                                                        ))
                                                                }
                                                            </div>

                                                            <input
                                                                id="dropzone-fileee"
                                                                type="file"
                                                                className="hidden"
                                                                onChange={handleFileChange}
                                                                required
                                                            />
                                                        </label>

                                                        <div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <label className='font-medium mb-3'>Profile Pic:</label>
                                                    <div className="flex items-center justify-center w-full">
                                                        <label
                                                            htmlFor="dropzone-file"
                                                            className={`flex flex-col items-center justify-center w-full h-44 cursor-pointer  `}
                                                        >
                                                            {/* 👇 Conditional Preview or Default SVG Instructions */}

                                                            <div className="flex items-center justify-start w-full h-full">
                                                                {
                                                                    imageProfilePreview ? (
                                                                        <img
                                                                            src={imageProfilePreview}
                                                                            alt="Preview"
                                                                            className="h-full object-contain border-2 border-gray-300 border-dashed rounded-lg"
                                                                        />
                                                                    ) :

                                                                        (editPersonal?.personalData?.profilePic?.filename ? (
                                                                            <img
                                                                                src={`${api}/upload/${editPersonal.personalData.profilePic.filename}`}
                                                                                alt={editPersonal.personalData.profilePic.filename}
                                                                                className="h-full object-contain border-2 border-gray-300 border-dashed rounded-lg"
                                                                            />


                                                                        ) : (
                                                                            <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                                                                <svg className="w-8 h-8 mb-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                                                                </svg>
                                                                                <p className="mb-2 text-sm text-gray-500"><span className="font-semibold">Click to upload</span> or drag and drop</p>
                                                                                <p className="text-xs text-gray-500">SVG, PNG, JPG or GIF (MAX. 800x400px)</p>
                                                                            </div>
                                                                        ))
                                                                }
                                                            </div>

                                                            <input
                                                                id="dropzone-file"
                                                                type="file"
                                                                className="hidden"
                                                                onChange={handleProfileFileChange}
                                                                required
                                                            />
                                                        </label>

                                                        <div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>


                                            {/* Submit Button */}
                                            <div className="mt-4 pt-2">
                                                <button
                                                    type="submit"
                                                    onClick={handleSubmit}

                                                    className=" float-end py-2 px-4 rounded-md text-base font-medium text-white bg-primary-800 hover:bg-primary-700 focus:outline-none flex align-items-center gap-2"
                                                >
                                                    Next
                                                    {/* <FaArrowRightLong /> */}
                                                </button>


                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    );
}
